module.exports = __webpack_public_path__ + "static/media/21ECLAC6.effc9c3a.jpg";